import { render, staticRenderFns } from "./GalleryFolder.vue?vue&type=template&id=4f2c7acc&scoped=true"
import script from "./GalleryFolder.vue?vue&type=script&lang=js"
export * from "./GalleryFolder.vue?vue&type=script&lang=js"
import style0 from "./GalleryFolder.vue?vue&type=style&index=0&id=4f2c7acc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2c7acc",
  null
  
)

export default component.exports